import { Drawer, Grid, makeStyles } from "@material-ui/core";
import { useAuth, useVerifyPermission } from "@airborne/react-admin";
import * as React from "react";
import { useDataProvider } from "react-admin";
import FilterToolbar from "../../Components/FiltersToolbar/FilterToolbar";
import { FilterInputType, FilterTypes } from "../../Enums/FilterTypes";
import { ExcelExport } from "../../Helper/ExportExcel";
import Comment from "./Comment";
import { DataGridColumns } from "./DataGridColumns";
import PDFViewer from "./PDFViewer";
import ShopReportFields from "./ShopReportFields";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";
const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: "25%",
  },
}));
export const ShopReport = props => {
  useVerifyPermission("customroutes", "shopreport.read");
  const { user } = useAuth();
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [isPDFViewer, setIsPDFViewer] = React.useState(false);
  const [isShopReportFields, setIsShopReportFields] = React.useState(false);
  const [shopReport, setShopReport] = React.useState<any>({});
  const [customers, setCustomers] = React.useState<any>([]);
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const HasDocumentFilters = [
    { Description: "TRUE", Value: true },
    { Description: "FALSE", Value: false },
  ];

  React.useEffect(() => {
    getCustomers();
  }, []);

  const getCustomers = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerCode", order: "ASC" },
        filter: {},
      })
      .then(response => {
        const data = response.data ?? [];
        // customerCode'a göre distinct yapmak için Map kullanıyoruz
        const uniqueCustomers = Array.from(new Map(data.map(customer => [customer.customerCode, customer])).values());
        setCustomers(uniqueCustomers);
      });
  };
  const remarkAddClick = record => {
    setIsMatchCreate(true);
    setShopReport(record);
  };
  const handleClose = () => {
    setIsMatchCreate(false);
  };
  const handlePDFViewer = record => {
    setIsPDFViewer(true);
    setShopReport(record);
  };
  const handleShopReportFields = record => {
    setIsShopReportFields(true);
    setShopReport(record);
  };
  const handleShopReportFieldsClose = () => {
    setIsShopReportFields(false);
  };
  const handlePDFViewerClose = () => {
    setIsPDFViewer(false);
  };
  const ExportToExcel = data => {
    var tempData = [...data];
    const reportData = [
      ...tempData.map(x => [
        x.customerCode,
        x.customerPo,
        x.pn,
        x.sn,
        x.pnDescription,
        x.scheduleStartDate,
        x.wo,
        x.roNumber,
        x.roStatus,
        x.roClosedDate,
        x.pnCondition,
        x.faultConfirm,
        x.hardTime,
        x.vendor,
        x.path || x.pathWo,
        x.workDone,
        x.shopFinding,
        x.usedMaterials,
      ]),
    ];
    ExcelExport(
      [
        {
          header: "Customer",
          key: "Customer",
        },
        {
          header: "Customer Po",
          key: "Customer Po",
        },
        {
          header: "PN",
          key: "PN",
        },
        {
          header: "SN",
          key: "SN",
        },
        {
          header: "PN Description",
          key: "PN Description",
        },
        {
          header: "Schedule Start Date",
          key: "Schedule Start Date",
        },
        {
          header: "Wo",
          key: "Wo",
        },
        {
          header: "Ro",
          key: "Ro",
        },
        {
          header: "Ro Status",
          key: "Ro Status",
        },
        {
          header: "Ro Closed Date",
          key: "Ro Closed Date",
        },
        {
          header: "Pn Condition",
          key: "Pn Condition",
        },
        {
          header: "Fault Confirm",
          key: "Fault Confirm",
        },
        {
          header: "Hard Time",
          key: "Hard Time",
        },
        {
          header: "Vendor",
          key: "Vendor",
        },
        {
          header: "Document Path",
          key: "Document Path",
          width: 200,
        },
        {
          header: "Work Done",
          key: "Work Done",
          width: 350,
        },
        {
          header: "Shop Finding",
          key: "Shop Finding",
          width: 300,
        },
        {
          header: "Used Materials",
          key: "Used Materials",
          width: 300,
        },
      ],
      reportData,
      "Shop Report"
    );
  };
  return (
    <Grid container>
      <Grid item xs={isMatchCreate ? 8 : 12}>
        <Grid container alignItems="center" style={{ marginTop: 10, marginBottom: 5, marginLeft: 15 }}></Grid>
        <PoolList
          {...props}
          // pagination={<CustomPagination />}
          title={"Shop Report"}
          hasCreate={false}
          exporter={ExportToExcel}
          resource={"shopreports"}
          basePath={"shopreports"}
          hasBulkActions={false}
          filterDefaultValues={
            user?.isCustomer
              ? {
                  customerCode__eq: user?.customerCode?.includes("-O") ? user?.relatedCustomerCode : user?.customerCode,
                }
              : {}
          }
          filters={
            <FilterToolbar
              dataSource={[
                {
                  style: { minWidth: "250px" },
                  source: "customerCode",
                  inputType: FilterInputType.Select,
                  label: "Customer",
                  optionText: "customerCode",
                  optionValue: "customerCode",
                  disabled: user?.isCustomer,
                  filterTypeChangeDisable: user?.isCustomer,
                  choices: [...customers],
                  showFilterSelect: !user?.isCustomer,
                },
                {
                  style: { minWidth: "250px" },
                  source: "customerPo",
                  inputType: FilterInputType.Text,
                  label: "Customer Po",
                },
                {
                  style: { minWidth: "250px" },
                  source: "refNo",
                  inputType: FilterInputType.Text,
                  label: "Ref No",
                },
                {
                  style: { minWidth: "250px" },
                  source: "pn",
                  inputType: FilterInputType.Text,
                  label: "Pn",
                },
                {
                  style: { minWidth: "250px" },
                  source: "sn",
                  inputType: FilterInputType.Text,
                  label: "Sn",
                },
                {
                  style: { minWidth: "250px" },
                  source: "pnDescription",
                  inputType: FilterInputType.Text,
                  label: "Pn Description",
                },
                {
                  style: { minWidth: "250px" },
                  source: "scheduleStartDate",
                  inputType: FilterInputType.Date,
                  label: "Schedule Start Date",
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.GreaterThan,
                },
                {
                  style: { minWidth: "250px" },
                  source: "scheduleStartDate",
                  inputType: FilterInputType.Date,
                  label: "Schedule Start Date",
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.LessThan,
                },
                {
                  style: { minWidth: "250px" },
                  source: "wo",
                  inputType: FilterInputType.Number,
                  label: "Wo",
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.Equals,
                },
                {
                  style: { minWidth: "250px" },
                  source: "roNumber",
                  inputType: FilterInputType.Number,
                  label: "Ro",
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.Equals,
                },
                {
                  style: { minWidth: "250px" },
                  source: "roStatus",
                  inputType: FilterInputType.Text,
                  label: "Ro Status",
                },
                {
                  style: { minWidth: "250px" },
                  source: "roClosedDate",
                  inputType: FilterInputType.Date,
                  label: "Ro Closed Date",
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.GreaterThan,
                },
                {
                  style: { minWidth: "250px" },
                  source: "roClosedDate",
                  inputType: FilterInputType.Date,
                  label: "Ro Closed Date",
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.LessThan,
                },
                {
                  style: { minWidth: "250px" },
                  source: "pnCondition",
                  inputType: FilterInputType.Text,
                  label: "Pn Condition",
                },
                {
                  style: { minWidth: "250px" },
                  source: "faultConfirm",
                  inputType: FilterInputType.Text,
                  label: "Fault Confirm",
                },
                {
                  style: { minWidth: "250px" },
                  source: "hardTime",
                  inputType: FilterInputType.Text,
                  label: "Hard Time",
                },
                {
                  style: { minWidth: "250px" },
                  source: "vendor",
                  inputType: FilterInputType.Text,
                  label: "Vendor Code",
                },
                {
                  source: "hasDocument",
                  inputType: FilterInputType.Select,
                  label: "Has Document",
                  filterTypeChangeDisable: true,
                  filterType: FilterTypes.Equals,
                  choices: HasDocumentFilters,
                  optionValue: "Value",
                  optionText: "Description",
                  resettable: false,
                  showFilterSelect: !user?.isCustomer,
                },
              ]}
            />
          }
        >
          <DataGridColumns
            remarkAddClick={remarkAddClick}
            handlePDFViewer={handlePDFViewer}
            handleShopReportFields={handleShopReportFields}
          />
        </PoolList>
      </Grid>
      {isMatchCreate && (
        <Grid item xs={4}>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            open={isMatchCreate}
            anchor="right"
            onClose={handleClose}
          >
            {isMatchCreate ? (
              <Comment
                onCancel={handleClose}
                shopReport={shopReport}
                resource="shopreportnotes"
                basePath="shopreportnotes"
              />
            ) : null}
          </Drawer>
        </Grid>
      )}
      <Grid item xs={isMatchCreate ? 9 : 12}>
        {isPDFViewer && <PDFViewer open={isPDFViewer} shopReport={shopReport} handleClose={handlePDFViewerClose} />}
      </Grid>
      <Grid>
        {isShopReportFields && (
          <ShopReportFields
            open={isShopReportFields}
            shopReport={shopReport}
            handleClose={handleShopReportFieldsClose}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default ShopReport;
